/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {SimpleChip} from '@ion/features/src/search/SimpleChip';
import {dlsAlt} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export type JobSearchEngineChipProps = {
  chip: {
    field: string;
    keyword: string;
    disableDelete?: boolean;
  };
  onDelete: (chip: any) => void;
  fieldLabels: Record<string, string>;
};

const useStyles = makeStyles((theme: DLSTheme) => ({
  deleteIcon : {
    paddingTop  : 4,
    marginRight : '4px !important'
  },
  chipLabel : {
    ...dlsAlt('typography', 'label2'),
    fontWeight    : 400,
    letterSpacing : '0px'
  }
}));

/**
 * The `AutocompleteSearchChip` component displays a Chip with the specified field and keyword.
 */
const AutocompleteSearchChip = ({chip, onDelete, fieldLabels}: JobSearchEngineChipProps) => {
  const classes = useStyles();
   
  return (
    <SimpleChip query={{
      label     : `${fieldLabels[chip?.field]}: ${chip?.keyword}`,
      attribute : fieldLabels[chip?.field]
    }}
    classes={{
      label      : classes.chipLabel,
      deleteIcon : classes.deleteIcon
    }}
    radius={'32px'}
    onRemove={!chip?.disableDelete ? function(e) { onDelete(chip); } : null} />
  );
};

export default AutocompleteSearchChip;
